
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { TeamUserRoleDef, CompanyUserRoleDef, isLightHexColor } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'RoleDefBadge',
	props: {
		roleDef: {
			type: Object as () => TeamUserRoleDef | CompanyUserRoleDef | null,
			default: null,
		},
		useCase: {
			type: String,
			required: true,
			validator: (val: string) => ['company', 'team'].includes(val),
		},
		loading: {
			type: Boolean,
			default: false,
		},
		fallbackText: {
			type: String,
			default: 'No Role',
		},
		badgeClass: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapGetters([
			'companyClubOfferBenefits',
		]),
		shouldDisplayRoleName (): boolean {
			return !!(this.useCase === 'company' || this.companyClubOfferBenefits.isEnterprise);
		},
		displayText(): string {
			return (
				(this.shouldDisplayRoleName && this.roleDef?.name) ||
				this.fallbackText
			);
		},
		roleBadgeStyle(): Record<string, string> {
			if (this.shouldDisplayRoleName) {
				const bgColor: string = this.roleDef?.color || '#000000';
				const textColor: string = this.roleDef?.color && isLightHexColor(this.roleDef.color)
					? 'var(--grey-900) !important'
					: 'var(--grey-200) !important';

				return {
					backgroundColor: bgColor,
					color: textColor,
				};
			}

			return {
				fontWeight: 'normal',
				color: 'var(--grey-200) !important',
			};
		},
	},
});
